import { datadogLogs } from "@datadog/browser-logs";
import { useQuery } from "@tanstack/react-query";
import { downloadTrackSnippet } from "../../store/actions/audioService";
import { useAppDispatch } from "../../store/hooks";
import { QUERY_KEYS } from "../../constants/queryKeys";

interface DownloadTrackSnippetParams {
  fileVersionId?: number;
}

export const useFetchTrackSnippet = ({
  fileVersionId,
}: DownloadTrackSnippetParams) => {
  const dispatch = useAppDispatch();

  return useQuery({
    enabled: Boolean(fileVersionId),
    queryKey: [QUERY_KEYS.FETCH_TRACK_SNIPPET, fileVersionId],
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchInterval: false,
    retry: 0,
    refetchOnMount: true,
    queryFn: async () => {
      if (!fileVersionId) {
        return;
      }
      try {
        return await dispatch(
          downloadTrackSnippet({
            fileVersionId,
          }),
        ).unwrap();
      } catch (e) {
        datadogLogs.logger.error("Error downloading snippet", {
          fileVersionId,
        });
      }
    },
  });
};
